<template>
  <div id="index">
    <el-container>
      <el-container>
        <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
          <el-main>
            <el-breadcrumb
              separator-class="el-icon-arrow-right"
              class="mainBread"
            >
              <el-breadcrumb-item>首页</el-breadcrumb-item>
              <el-breadcrumb-item>设备报表</el-breadcrumb-item>
              <el-breadcrumb-item>空压机统计报表</el-breadcrumb-item>
            </el-breadcrumb>
            <el-form
              ref="formselect"
              :model="formselect"
              label-width="100px"
              class="queryform_div"
            >
              <el-row :gutter="24">
                <el-col :md="8" :sm="12" :xs="24">
                  <el-form-item label="空压机型号">
                    <el-cascader
                      v-model="formselect.value1"
                      placeholder="请输入"
                      :options="airoptions"
                      :props="{ multiple: true, checkStrictly: true }"
                      collapse-tags
                      style="width: 100%"
                      size="small"
                    ></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :md="8" :sm="12" :xs="24">
                  <el-form-item label="客户区域">
                    <el-select
                      v-model="formselect.value2"
                      multiple
                      filterable
                      collapse-tags
                      :placeholder="$t('desc.select')"
                      style="width: 100%"
                      size="small"
                    >
                      <el-option value="全部">全部</el-option>
                      <el-option value="华东">华东</el-option>
                      <el-option value="华南">华南</el-option>
                      <el-option value="中西">中西</el-option>
                      <el-option value="东北">东北</el-option>
                      <el-option value="华北">华北</el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :md="8" :sm="12" :xs="24">
                  <el-form-item :label="$t('title.customerCenter')">
                    <el-select
                      v-model="formselect.value3"
                      multiple
                      filterable
                      collapse-tags
                      :placeholder="$t('desc.select')"
                      style="width: 100%"
                      size="small"
                    >
                      <el-option value="全部">全部</el-option>
                      <el-option value="上海">上海</el-option>
                      <el-option value="北京">北京</el-option>
                      <el-option value="苏州">苏州</el-option>
                      <el-option value="杭州">杭州</el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :md="8" :sm="12" :xs="24">
                  <el-form-item label="行业">
                    <el-select
                      v-model="formselect.value4"
                      multiple
                      filterable
                      collapse-tags
                      :placeholder="$t('desc.select')"
                      style="width: 100%"
                      size="small"
                    >
                      <el-option value="全部">全部</el-option>
                      <el-option value="化工">化工</el-option>
                      <el-option value="制药">制药</el-option>
                      <el-option value="吹瓶">吹瓶</el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :md="8" :sm="24" :xs="24">
                  <el-form-item label="运行时长">
                    <el-input placeholder="" v-model="formselect.value5"
                      size="small">
                      <template slot="prepend">大于</template>
                      <template slot="append">小时</template>
                    </el-input>
                  </el-form-item>
                </el-col>


              <el-col :md="24" :sm="24" :xs="24" style="margin-top:10px;">
                <el-button type="primary"
                      size="small">统计</el-button>
                <el-button
                      size="small">{{$t("button.reset")}}</el-button>
              </el-form-item>
                         </el-col>
                 </el-row>
            </el-form>
            <el-button type="primary" icon="el-icon-download"
              >导出报表</el-button
            >
            <div style="margin-top: 10px">
              <div class="tableDiv">
              <el-table
                :data="tableData1"
                stripe
                style="width: 100%"
                max-height="280"
                :empty-text="$t('desc.noData')"
              >
                <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="50"
                  fixed="left"
                >
                </el-table-column>
                <el-table-column
                  prop="KSN"
                  :label="$t('desc.airCompressorSN')"
                    min-width="100px"
                  fixed="left"
                >
                </el-table-column>
                <el-table-column prop="ClientID" label="客户代码"    min-width="100px">
                </el-table-column>
                <el-table-column prop="ClientName" label="客户名称"    min-width="200px">
                </el-table-column>
                <el-table-column prop="ClientType" label="行业"    min-width="150px">
                </el-table-column>
                <el-table-column prop="ClientArea" label="客户区域"    min-width="220px">
                </el-table-column>
                <el-table-column prop="KType" label="产品线"    min-width="100px">
                </el-table-column>
                <el-table-column prop="KProduct" label="大类"   min-width="100px">
                </el-table-column>
                <el-table-column prop="KSmall" label="小类"    min-width="100px">
                </el-table-column>
                <el-table-column prop="KPower" label="机型"    min-width="100px">
                </el-table-column>
                <el-table-column prop="CCN" label="控制器软件CCN号"   min-width="150px">
                </el-table-column>
                <el-table-column
                  prop="KService"
                  label="空压机服务类型"
                   min-width="150px"
                >
                </el-table-column>
                <el-table-column prop="Time" label="运行时长"    min-width="100px">
                </el-table-column>
                <el-table-column
                  label="当前状态"
                   min-width="80"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-tag
                      :type="scope.row.State === '正常' ? 'success' : 'danger'"
                      disable-transitions
                      >{{ scope.row.State }}</el-tag
                    >
                  </template>
                </el-table-column>
              </el-table>
              </div>
            </div>
            <div class="ReportDiv" style="margin-top:12px">
              <el-row :gutter="24">
                <el-col :md="8" :sm="8" :xs="24">
                  <div class="block">
                    <h4>故障空压机台数</h4>
                    <span>2</span>
                  </div>
                </el-col>
                <el-col :md="8" :sm="8" :xs="24">
                  <div class="block">
                    <h4>总台数</h4>
                    <span>16</span>
                  </div>
                </el-col>
                <el-col :md="8" :sm="8" :xs="24">
                  <div class="block">
                    <h4>故障率</h4>
                    <span>12.5%</span>
                  </div>
                </el-col>
                <el-col :md="12" :sm="24" :xs="24">
                  <div class="block">
                    <h4>各型号总数占比</h4>
                    <div
                      class="echarts"
                      id="Kchart1a"
                      style="height: 200px"
                    ></div>
                  </div>
                </el-col>
                <el-col :md="12" :sm="24" :xs="24">
                  <div class="block">
                    <h4>各型号故障率排行</h4>
                    <div
                      class="echarts"
                      id="Kchart1b"
                      style="height: 200px"
                    ></div>
                  </div>
                </el-col>
                <el-col :md="12" :sm="24" :xs="24">
                  <div class="block">
                    <h4>各行业总数占比</h4>
                    <div
                      class="echarts"
                      id="Kchart2a"
                      style="height: 200px"
                    ></div>
                  </div>
                </el-col>
                <el-col :md="12" :sm="24" :xs="24">
                  <div class="block">
                    <h4>各行业故障率排行</h4>
                    <div
                      class="echarts"
                      id="Kchart2b"
                      style="height: 200px"
                    ></div>
                  </div>
                </el-col>
                <el-col :md="12" :sm="24" :xs="24">
                  <div class="block">
                    <h4>各区域总数占比</h4>
                    <div
                      class="echarts"
                      id="Kchart3a"
                      style="height: 200px"
                    ></div>
                  </div>
                </el-col>
                <el-col :md="12" :sm="24" :xs="24">
                  <div class="block">
                    <h4>各区域故障率排行</h4>
                    <div
                      class="echarts"
                      id="Kchart3b"
                      style="height: 200px"
                    ></div>
                  </div>
                </el-col>
                <el-col :md="12" :sm="24" :xs="24">
                  <div class="block">
                    <h4>各客户中心总数占比</h4>
                    <div
                      class="echarts"
                      id="Kchart4a"
                      style="height: 200px"
                    ></div>
                  </div>
                </el-col>
                <el-col :md="12" :sm="24" :xs="24">
                  <div class="block">
                    <h4>各客户中心故障率排行</h4>
                    <div
                      class="echarts"
                      id="Kchart4b"
                      style="height: 200px"
                    ></div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "index",

  computed: mapState({
    isCollapse: (state) => state.isCollapse,
  }),
  data() {
    return {
      formselect: {},
      airoptions: [
        {
          value: 1,
          label: "螺杆机",
          children: [
            {
              value: 11,
              label: "无油变频",
              children: [
                {
                  value: 111,
                  label: "Nirvana-OF",
                },
                {
                  value: 112,
                  label: "Sierra(CD26 VSD)",
                },
              ],
            },
            {
              value: 12,
              label: "无油定频",
              children: [
                {
                  value: 121,
                  label: "Sierra(CD8)",
                },
                {
                  value: 122,
                  label: "Sierra(CD14)",
                },
                {
                  value: 123,
                  label: "Sierra(CD26)",
                },
                {
                  value: 124,
                  label: "E200-355(CD26)",
                },
              ],
            },
          ],
        },
      ],
      tableData1: [
        {
          KSN: "52156235",
          ClientID: "AS008828",
          ClientName: "河北双吉化工有限公司",
          ClientType: "钢铁 31",
          ClientArea: "华东地区",
          KType: "螺杆机",
          KProduct: "无油变频",
          KSmall: "	Nirvana-OF",
          KPower: "45-75KW",
          CCN: "24236028",
          KService: "PackageCARE",
          State: "故障",
          Time: "1562",
        },
        {
          KSN: "52156235",
          ClientID: "AS008828",
          ClientName: "河北双吉化工有限公司",
          ClientType: "钢铁 31",
          ClientArea: "华东地区",
          KType: "螺杆机",
          KProduct: "无油变频",
          KSmall: "	Nirvana-OF",
          KPower: "45-75KW",
          CCN: "24236028",
          KService: "PackageCARE",
          State: "故障",
          Time: "1562",
        },
        {
          KSN: "52156235",
          ClientID: "AS008828",
          ClientName: "河北双吉化工有限公司",
          ClientType: "钢铁 31",
          ClientArea: "华东地区",
          KType: "螺杆机",
          KProduct: "无油变频",
          KSmall: "	Nirvana-OF",
          KPower: "45-75KW",
          CCN: "24236028",
          KService: "PackageCARE",
          State: "正常",
          Time: "1562",
        },
        {
          KSN: "52156235",
          ClientID: "AS008828",
          ClientName: "河北双吉化工有限公司",
          ClientType: "钢铁 31",
          ClientArea: "华东地区",
          KType: "螺杆机",
          KProduct: "无油变频",
          KSmall: "	Nirvana-OF",
          KPower: "45-75KW",
          CCN: "24236028",
          KService: "PackageCARE",
          State: "正常",
          Time: "1562",
        },
        {
          KSN: "52156235",
          ClientID: "AS008828",
          ClientName: "河北双吉化工有限公司",
          ClientType: "钢铁 31",
          ClientArea: "华东地区",
          KType: "螺杆机",
          KProduct: "无油变频",
          KSmall: "	Nirvana-OF",
          KPower: "45-75KW",
          CCN: "24236028",
          KService: "PackageCARE",
          State: "正常",
          Time: "1562",
        },
        {
          KSN: "52156235",
          ClientID: "AS008828",
          ClientName: "河北双吉化工有限公司",
          ClientType: "钢铁 31",
          ClientArea: "华东地区",
          KType: "螺杆机",
          KProduct: "无油变频",
          KSmall: "	Nirvana-OF",
          KPower: "45-75KW",
          CCN: "24236028",
          KService: "PackageCARE",
          State: "正常",
          Time: "1562",
        },
        {
          KSN: "52156235",
          ClientID: "AS008828",
          ClientName: "河北双吉化工有限公司",
          ClientType: "钢铁 31",
          ClientArea: "华东地区",
          KType: "螺杆机",
          KProduct: "无油变频",
          KSmall: "	Nirvana-OF",
          KPower: "45-75KW",
          CCN: "24236028",
          KService: "PackageCARE",
          State: "正常",
          Time: "1562",
        },
        {
          KSN: "52156235",
          ClientID: "AS008828",
          ClientName: "河北双吉化工有限公司",
          ClientType: "钢铁 31",
          ClientArea: "华东地区",
          KType: "螺杆机",
          KProduct: "无油变频",
          KSmall: "	Nirvana-OF",
          KPower: "45-75KW",
          CCN: "24236028",
          KService: "PackageCARE",
          State: "正常",
          Time: "1562",
        },
        {
          KSN: "52156235",
          ClientID: "AS008828",
          ClientName: "河北双吉化工有限公司",
          ClientType: "钢铁 31",
          ClientArea: "华东地区",
          KType: "螺杆机",
          KProduct: "无油变频",
          KSmall: "	Nirvana-OF",
          KPower: "45-75KW",
          CCN: "24236028",
          KService: "PackageCARE",
          State: "正常",
          Time: "1562",
        },
        {
          KSN: "52156235",
          ClientID: "AS008828",
          ClientName: "河北双吉化工有限公司",
          ClientType: "钢铁 31",
          ClientArea: "华东地区",
          KType: "螺杆机",
          KProduct: "无油变频",
          KSmall: "	Nirvana-OF",
          KPower: "45-75KW",
          CCN: "24236028",
          KService: "PackageCARE",
          State: "正常",
          Time: "1562",
        },
        {
          KSN: "52156235",
          ClientID: "AS008828",
          ClientName: "河北双吉化工有限公司",
          ClientType: "钢铁 31",
          ClientArea: "华东地区",
          KType: "螺杆机",
          KProduct: "无油变频",
          KSmall: "	Nirvana-OF",
          KPower: "45-75KW",
          CCN: "24236028",
          KService: "PackageCARE",
          State: "正常",
          Time: "1562",
        },
        {
          KSN: "52156235",
          ClientID: "AS008828",
          ClientName: "河北双吉化工有限公司",
          ClientType: "钢铁 31",
          ClientArea: "华东地区",
          KType: "螺杆机",
          KProduct: "无油变频",
          KSmall: "	Nirvana-OF",
          KPower: "45-75KW",
          CCN: "24236028",
          KService: "PackageCARE",
          State: "正常",
          Time: "1562",
        },
        {
          KSN: "52156235",
          ClientID: "AS008828",
          ClientName: "河北双吉化工有限公司",
          ClientType: "钢铁 31",
          ClientArea: "华东地区",
          KType: "螺杆机",
          KProduct: "无油变频",
          KSmall: "	Nirvana-OF",
          KPower: "45-75KW",
          CCN: "24236028",
          KService: "PackageCARE",
          State: "正常",
          Time: "1562",
        },
        {
          KSN: "52156235",
          ClientID: "AS008828",
          ClientName: "河北双吉化工有限公司",
          ClientType: "钢铁 31",
          ClientArea: "华东地区",
          KType: "螺杆机",
          KProduct: "无油变频",
          KSmall: "	Nirvana-OF",
          KPower: "45-75KW",
          CCN: "24236028",
          KService: "PackageCARE",
          State: "正常",
          Time: "1562",
        },
        {
          KSN: "52156235",
          ClientID: "AS008828",
          ClientName: "河北双吉化工有限公司",
          ClientType: "钢铁 31",
          ClientArea: "华东地区",
          KType: "螺杆机",
          KProduct: "无油变频",
          KSmall: "	Nirvana-OF",
          KPower: "45-75KW",
          CCN: "24236028",
          KService: "PackageCARE",
          State: "正常",
          Time: "1562",
        },
        {
          KSN: "52156235",
          ClientID: "AS008828",
          ClientName: "河北双吉化工有限公司",
          ClientType: "钢铁 31",
          ClientArea: "华东地区",
          KType: "螺杆机",
          KProduct: "无油变频",
          KSmall: "	Nirvana-OF",
          KPower: "45-75KW",
          CCN: "24236028",
          KService: "PackageCARE",
          State: "正常",
          Time: "1562",
        },
      ],
      GSNform: [],
      Linecolor: [
        "#28739A",
        "#51A470",
        "#FCBC5D",
        "#B2865D",
        "#4A6AB5",
        "#798ED6",
        "#CF554A",
        "#BECAD8",
        "#48BCAF",
        "#A576C6",
        "#93C6B4",
        "#34A2BC",
      ],

      // Linecolor: [
      //   "#DD6B66",
      //   "#759AA0",
      //   "#FDAC94",
      //   "#8DC1A9",
      //   "#EA7E53",
      //   "#EEDD78",
      //   "#73A373",
      //   "#73B9BC",
      //   "#7289AB",
      //   "#91CA8C",
      // ],
      DataDeviceType: [
        { value: 45, name: "sierra(CD26)VSD" },
        { value: 40, name: "sierra(CD26)" },
        { value: 35, name: "Nirvana-OF" },
        { value: 30, name: "sierra(CD14)" },
        { value: 25, name: "E200-355(CD14)" },
        { value: 20, name: "E200-355(CD26)" },
        { value: 15, name: "sierra(CD26)VSD" },
        { value: 10, name: "sierra(CD26)" },
        { value: 5, name: "Nirvana-OF" },
        { value: 5, name: "sierra(CD14)" },
      ],
      DataDeviceTypeWarning: [
        // 百分比数值
        { value: 100, name: "sierra(CD26)VSD" },
        { value: 90, name: "sierra(CD26)" },
        { value: 80, name: "Nirvana-OF" },
        { value: 70, name: "sierra(CD14)" },
        { value: 60, name: "E200-355(CD14)" },
        { value: 50, name: "sierra(CD26)VSD" },
        { value: 40, name: "sierra(CD26)" },
        { value: 30, name: "Nirvana-OF" },
        { value: 20, name: "sierra(CD14)" },
        { value: 10, name: "E200-355(CD14)" },
      ],

      DataIndustry: [
        { value: 6, name: "油气开采" },
        { value: 1, name: "其它采矿业" },
        { value: 4, name: "开采辅助活动" },
        { value: 3, name: "公共事业" },
        { value: 6, name: "食品" },
        { value: 6, name: "油气开采" },
        { value: 1, name: "其它采矿业" },
        { value: 4, name: "开采辅助活动" },
        { value: 3, name: "公共事业" },
        { value: 6, name: "食品" },
      ],
      DataIndustryWarning: [
        // 百分比数值
        { value: 20, name: "油气开采" },
        { value: 14.3, name: "其它采矿业" },
        { value: 13, name: "开采辅助活动" },
        { value: 12, name: "公共事业" },
        { value: 12, name: "食品" },
        { value: 10, name: "油气开采" },
        { value: 7, name: "其它采矿业" },
        { value: 3, name: "开采辅助活动" },
        { value: 3, name: "公共事业" },
        { value: 3, name: "食品" },
      ],

      DataArea: [
        { value: 12, name: "华东地区" },
        { value: 2, name: "华南地区" },
        { value: 1, name: "中南地区" },
        { value: 3, name: "华北地区" },
        { value: 1, name: "东北地区" },
      ],
      DataAreaWarning: [
        // 百分比数值
        { value: 28.6, name: "华东地区" },
        { value: 28.6, name: "华南地区" },
        { value: 14.3, name: "中南地区" },
        { value: 14.3, name: "华北地区" },
        { value: 14.3, name: "东北地区" },
      ],

      DataCenter: [
        { value: 4, name: "上海" },
        { value: 2, name: "苏州" },
        { value: 1, name: "杭州" },
        { value: 3, name: "北京" },
        { value: 1, name: "天津" },
        { value: 2, name: "厦门" },
        { value: 1, name: "无锡" },
        { value: 1, name: "武汉" },
      ],
      DataCenterWarning: [
        // 百分比数值
        { value: 33.3, name: "上海" },
        { value: 16.7, name: "苏州" },
        { value: 16.7, name: "杭州" },
        { value: 16.7, name: "北京" },
        { value: 16.7, name: "天津" },
        { value: 0, name: "厦门" },
        { value: 0, name: "无锡" },
        { value: 0, name: "武汉" },
      ],
    };
  },

  methods: {
    handleAccredit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    onSubmit() {},

    initPie(Data,name) {
      var temp = {
        toolbox: {
          right: 0,
          top: 0,
          feature: {
            saveAsImage: {
              iconStyle: {
                emphasis: {
                  textPosition: "left",
                },
              },
              backgroundColor: "#242731"
            },
          },
        },

        series: [
          {
            name: name,
            type: "pie",
            radius: ["60%", "65%"],
            center: ["50%", "50%"],
            color: "#767778",
            itemStyle: {
              normal: {
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
              },
            },
            hoverAnimation: false,
            data: [
              {
                value: 1,
              },
            ],
            z: 2,
          },
          {
            name: "",
            type: "pie",
            radius: "55%",
            center: ["50%", "50%"],
            color: this.Linecolor,
            data: Data.sort(function (a, b) { return a.value - b.value; }),
            labelLine: {
              show: true,
              length: 20,
              length2: 30,
            },
            itemStyle: {
              borderWidth: 1,
              borderColor: "#C2C2C2",
            },
            label: {
              color: "#767778",
              lineHeight: 7,
              formatter: function (params) {
                var percent = 0;
                var total = 0;
                for (var i = 0; i < Data.length; i++) {
                  total += Data[i].value;
                }
                percent = ((params.value / total) * 100).toFixed(0);
                if (params.name !== "") {
                  return (
                    params.name +": "+  percent + "%"
                  );
                } else {
                  return "";
                }
              },
            },
          },
        ],
      };
      return temp;
    },
    initBar(Data) {
      var colorL = this.Linecolor;
      var temp = {

        toolbox: {
          right: 0,
          top: 0,
          feature: {
            saveAsImage: {
              iconStyle: {
                emphasis: {
                  textPosition: "left",
                },
              },
              backgroundColor: "#242731"
            },
          },
        },
        grid: {
          top: 30,
          left: 40,
          right: 0,
          bottom: 10,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: Data.map((item) => item.name),
            axisTick: {
              alignWithLabel: true,
            },
            axisLabel: {
              textStyle: {
                color: "#767778",
                fontSize: 10,
              },
              interval: 0,
              rotate: 30,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
             splitNumber: 3,
            axisLabel: {
              textStyle: {
                color: "#767778",
                fontSize: 12,
              },
            },
            max: 100,
            min: 0,
          },
        ],

        series: [
          {
            name: "故障率",
            type: "bar",
            barWidth: "60%",
            data: Data.map((item) => item.value),
              label: {
              show: true,
              position: "top",
               formatter: '{c}%'
            },
            itemStyle: {
              normal: {
                barBorderRadius: 5,
                color: function (params) {
                  var num = colorL.length;
                  return colorL[params.dataIndex % num];
                },
              },
            },

          },
        ],
      };
      return temp;
    },
    initEcharts() {
      var Kchart1a = this.$echarts.init(document.getElementById("Kchart1a"));
      Kchart1a.setOption(this.initPie(this.DataDeviceType,"各型号总数占比"));
      var Kchart1b = this.$echarts.init(document.getElementById("Kchart1b"));
      Kchart1b.setOption(this.initBar(this.DataDeviceTypeWarning));

      var Kchart2a = this.$echarts.init(document.getElementById("Kchart2a"));
      Kchart2a.setOption(this.initPie(this.DataIndustry,"各行业总数占比"));
      var Kchart2b = this.$echarts.init(document.getElementById("Kchart2b"));
      Kchart2b.setOption(this.initBar(this.DataIndustryWarning));

      var Kchart3a = this.$echarts.init(document.getElementById("Kchart3a"));
      Kchart3a.setOption(this.initPie(this.DataArea,"各区域总数占比"));
      var Kchart3b = this.$echarts.init(document.getElementById("Kchart3b"));
      Kchart3b.setOption(this.initBar(this.DataAreaWarning));

      var Kchart4a = this.$echarts.init(document.getElementById("Kchart4a"));
      Kchart4a.setOption(this.initPie(this.DataCenter,"各客户中心总数占比"));
      var Kchart4b = this.$echarts.init(document.getElementById("Kchart4b"));
      Kchart4b.setOption(this.initBar(this.DataCenterWarning));

      window.addEventListener("resize", () => {
        Kchart1a.resize();
        Kchart1b.resize();
        Kchart2a.resize();
        Kchart2b.resize();
        Kchart3a.resize();
        Kchart3b.resize();
        Kchart4a.resize();
        Kchart4b.resize();
      });
    },
  },
  created() {
    this.$nextTick(() => {
      this.initEcharts();
    });
  },
};
</script>

 <style scope>
 .el-form-item__content .el-input-group{
         vertical-align: middle;
 }
 .el-table__fixed-right{
   right:10px !important
 }
 </style>
